export default __webpack_public_path__ + "static/media/copyright.0d3689a5.svg";